export default __webpack_public_path__ + "static/media/sondeTemperature.16969adb.jpg";